<script>
import Layout from '../../layouts/main'

export default {
  name: 'AccessDenied',
  components: { Layout },
}
</script>

<template>
  <Layout>
    <div class="container-fluid">
    <div class="row justify-content-center mt-5">
      <div class="col-md-8 col-lg-6 text-center">
        <div class="card">
          <div class="card-body p-5">
            <h1 class="text-warning">Acesso não autorizado</h1>
            <p class="text-muted mb-0">
              Use o menu lateral para acessar uma funcionalidade permitida ao seu usuário.
            </p>
          </div>
        </div>
      </div>
    </div>
    </div>
  </Layout>
</template>
